export { default } from './ScoresTable';
